var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.002,
    height: 40,
    viewBox: "0 0 40.002 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(-455.998 -232)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149968",
    "data-name": "Rectangle 149968",
    width: 40,
    height: 40,
    transform: "translate(456 232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Visa-dark",
    transform: "translate(455.998 240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 40,
    height: 24,
    rx: 2,
    fill: "#26337a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    d: "M0,7.586,1.223,0H3.177L1.955,7.586H0",
    transform: "translate(16.5 8.142)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M5.865.318A4.832,4.832,0,0,0,4.114,0C2.181,0,.821,1.029.809,2.5.8,3.594,1.78,4.2,2.521,4.564c.762.371,1.018.609,1.015.941-.005.508-.608.741-1.17.741a3.915,3.915,0,0,1-1.841-.4L.273,5.728,0,7.426a5.9,5.9,0,0,0,2.178.4c2.054,0,3.388-1.017,3.4-2.591.007-.865-.514-1.52-1.642-2.061-.683-.352-1.1-.585-1.1-.941,0-.315.354-.653,1.12-.653a3.428,3.428,0,0,1,1.463.291l.176.087L5.865.318",
    transform: "translate(19.68 8.01)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M2.053,7.581H0L2.9.629A.964.964,0,0,1,3.927,0H5.438L7.019,7.58H5.205s-.177-.86-.238-1.136l-1.376,0h0l-1.124,0c-.075.2-.408,1.131-.411,1.14ZM3.805,2.768v0c-.064.173-.625,1.707-.778,2.117H4.649C4.574,4.522,4.212,2.774,4.2,2.7l-.132-.656c-.051.148-.125.348-.178.495v0c-.058.158-.081.223-.081.226Z",
    transform: "translate(25.121 8.149)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M4.826,0,2.913,5.172l-.2-1.051A5.825,5.825,0,0,0,0,.938L1.75,7.573H3.819L6.9,0H4.826",
    transform: "translate(10.035 8.148)",
    fill: "#fffffe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M3.178,0H.026L0,.157A6.561,6.561,0,0,1,4.749,4.125L4.064.64A.821.821,0,0,0,3.178,0",
    transform: "translate(7.993 8.143)",
    fill: "#ec982d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.089968a50ab0b0fb0f6eb7e9d99b1803.svg";
export { ForwardRef as ReactComponent };